/* src/app/admin-dashboard/audit-logs/audit-logs.component.css */
.audit-wrap {
  padding: 24px 28px;
  max-width: 1200px;
  margin: 0 auto;
}
.audit-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
.audit-header .sub {
  margin: 4px 0 20px;
  color: #6b7280;
  font-size: 14px;
}
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.filters .search {
  flex: 1 1 260px;
}
.filters mat-form-field {
  font-size: 14px;
}
.loading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6b7280;
  padding: 32px 0;
}
.empty {
  padding: 32px;
  text-align: center;
  color: #9ca3af;
  background: #f9fafb;
  border-radius: 8px;
}
.log-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.log-row {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.log-main {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
}
.log-main:hover {
  background: #f9fafb;
}
.badge {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .04em;
  padding: 3px 8px;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 auto;
}
.badge.delete {
  background: #dc2626;
}
.badge.create {
  background: #16a34a;
}
.badge.update {
  background: #2563eb;
}
.entity {
  font-weight: 600;
  flex: 0 0 auto;
}
.entity-id {
  color: #6b7280;
  font-family: monospace;
  font-size: 12px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.who {
  color: #111827;
  font-size: 13px;
}
.reason {
  color: #92400e;
  font-size: 13px;
  font-style: italic;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.spacer {
  flex: 1 1 auto;
}
.when {
  color: #9ca3af;
  font-size: 12px;
  white-space: nowrap;
}
.chev {
  color: #9ca3af;
}
.log-detail {
  border-top: 1px solid #f0f0f0;
  padding: 16px;
  background: #fbfbfd;
}
.meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.meta-grid label {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ca3af;
  letter-spacing: .04em;
  margin-bottom: 2px;
}
.meta-grid code {
  font-size: 12px;
  word-break: break-all;
}
.diff {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.diff-col {
  flex: 1 1 320px;
  min-width: 0;
}
.diff-col label {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ca3af;
  letter-spacing: .04em;
  margin-bottom: 4px;
}
.diff-col pre {
  margin: 0;
  padding: 12px;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  overflow-x: auto;
  max-height: 320px;
}
/*# sourceMappingURL=audit-logs.component.css.map */
